module.exports = __webpack_public_path__ + "images/tr_wework/ic-failed@2x-a5b82ca513f66ff97aad5f413e9d1bc5.png";